import React, { useState, useEffect } from 'react';
import heroImage from '../../../assets/images/dyslexia/hero_img.jpg';

const HeroSection = () => {
  const [imageHeight, setImageHeight] = useState(null);

  useEffect(() => {
    const img = new Image();
    img.src = heroImage;
    img.onload = () => {
      // Calculate height based on image's natural aspect ratio
      const aspectRatio = img.naturalHeight / img.naturalWidth;
      const height = window.innerWidth * aspectRatio;
      setImageHeight(height);
    };

    const handleResize = () => {
      if (img.complete) {
        const aspectRatio = img.naturalHeight / img.naturalWidth;
        const height = window.innerWidth * aspectRatio;
        setImageHeight(height);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      className="w-full bg-cover bg-center bg-no-repeat relative z-20"
      style={{
        backgroundImage: `url(${heroImage})`,
        height: imageHeight ? `${imageHeight}px` : 'auto',
        minHeight: '350px',
      }}
    >
      <div className="absolute top-0 left-0 w-full bg-headerBg/90 px-4 py-2 xs:py-4 xs:pb-4 sm:pb-1">
        <div className="flex items-start md:items-center flex-col md:flex-row md:gap-10 justify-normal md:justify-between  max-w-[1200px] mx-auto">
          <h1 className="text-white text-[20px] md:text-[28px] lg:text-[38px] 2xl:text-[40px] 3xl:text-[53px] font-[700] tracking-wide">
            Is It Dyslexia
          </h1>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
